import erp_cities from "../../../data/inspection-cities-final/erp_cities.json";
export var getCities = function getCities() {
  var _erp_cities$cities;
  return erp_cities === null || erp_cities === void 0 ? void 0 : (_erp_cities$cities = erp_cities.cities) === null || _erp_cities$cities === void 0 ? void 0 : _erp_cities$cities.filter(function (city) {
    return city.approved_for_inspection === true;
  });
};
export var getAllCities = function getAllCities() {
  return erp_cities === null || erp_cities === void 0 ? void 0 : erp_cities.cities;
};